import { INew_TableAction } from '@lla-platform/core/core-data-access'
import { ICategoryOverviewRequest } from '../../interfaces/category-overview.interface'
import { IGpPackageListRequest } from '../../interfaces/invoice-gp-package.interface'
import { IPackageUnperformedRequest } from '../../interfaces/package-unperformed.interface'
import { IArInvoiceRequest } from '../../interfaces/ar-invoices.interface'
import { IInvoiceGrossProfitRequest } from '../../interfaces/invoice-gross-profit.interface'
import { IPriceAdherenceRequest } from '../../interfaces/invoice-lines-report.interface'

export class GetArInvoicesSummary {
  static readonly type = '[arInvoices] Get Ar Invoices Summary'
  constructor(public payload: IArInvoiceRequest) {}
}

export class GetInvoicesListOverview {
  static readonly type = '[arInvoices] Get Invoices List Overview'
  constructor(public info: INew_TableAction) {}
}

export class GetArInvoicesList {
  static readonly type = '[arInvoices] Get Ar Invoices List'
  constructor(public info: INew_TableAction) {}
}

export class GetInvoicesGeoLocations {
  static readonly type = '[arInvoices] Get Invoices Geo Locations'
  constructor(public info: INew_TableAction) {}
}

export class GetGrossProfitList {
  static readonly type = '[arInvoices] Get Gross Profit List'
  constructor(public info: INew_TableAction) {}
}

export class GetInvoice {
  static readonly type = '[arInvoices] Get Invoice'
  constructor(public invoiceId: string) {}
}

export class GetGrossProfit {
  static readonly type = '[arInvoices] Get Gross Profit'
  constructor(public payload: IInvoiceGrossProfitRequest) {}
}

export class GetGpPackageList {
  static readonly type = '[arInvoices] Get Gp Package List'
  constructor(public info: INew_TableAction) {}
}

export class GetGpPackage {
  static readonly type = '[arInvoices] Get Gp Package'
  constructor(public payload: IGpPackageListRequest) {}
}

export class GetCategoryOverview {
  static readonly type = '[arInvoices] Get Category Overview'
  constructor(public payload: ICategoryOverviewRequest) {}
}

export class GetPackageUnperformed {
  static readonly type = '[arInvoices] Get Package Unperformed'
  constructor(public payload: IPackageUnperformedRequest) {}
}

export class GetInvoicePackageLinesList {
  static readonly type = '[arInvoices] Get Invoice Package Lines List'
  constructor(public info: INew_TableAction) {}
}

export class GetInvoiceLinesOverview {
  static readonly type = '[arInvoices] Get Invoice Lines Overview'
  constructor(public info: INew_TableAction) {}
}

export class GetInvoiceLinesPriceAdherence {
  static readonly type = '[arInvoices] Get Invoice Lines Price Adherence'
  constructor(public payload: IPriceAdherenceRequest) {}
}

export class GetInvoiceLinesList {
  static readonly type = '[arInvoices] Get Invoice Lines List'
  constructor(public info: INew_TableAction) {}
}
